import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import Pagination from '../../CommonUI/Pagination/Pagination';
import './Fundperformans.css';
import MarketMF from "../MarketMF";
import { Vortex } from 'react-loader-spinner'

function Fundperformans() {
    const [currentPage, setCurrentPage] = useState(1);
    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    const [DataFundPerformance, setDataFundPerformance] = useState([]);
    const [Shemedrop, setSheme] = useState('26');
    const [Performance, setPerformance] = useState('T');
    const [valueLi, setValueLi] = useState('1Week');

    const [loadingshow, setloadingshow] = useState(false);
    const [valuescheme, setvaluescheme] = useState('26');
    let getDataHoldingdrop, PageSize = 5;

    useEffect(() => {
        setloadingshow(true);
        window.scrollTo(0, 0)
        const getUrlMfTopHoldingDropDividend = BaseURL + "MfHoldingDrop";

        fetch(`${getUrlMfTopHoldingDropDividend}/compare/-`)
            .then((response) => response.json())
            .then((dataFundPerformance) => {
                getDataHoldingdrop = dataFundPerformance.data;
                setDataFundPerformance(getDataHoldingdrop);
                var codename = getDataHoldingdrop[0].VCLASS;
                setvaluescheme(codename)
                setloadingshow(false);

                // console.log(getDataHoldingdrop, "getDataHoldingdrop")
            })
            .catch((error) => {
            });

        const getUrl = BaseURL + "MfFundPerformance/";
        if (Performance === 'T') {

            fetch(`${getUrl}/15/${valueLi}/${Shemedrop}/ALL/${Performance}/ALL`)
                .then((response) => response.json())
                .then((data) => {

                    setData(data.data);
                    setloadingshow(false);
                    // console.log(data.data)
                })
                .catch((error) => {
                    //console.log("not found the api");
                });
        }
        else {
            fetch(`${getUrl}/15/${valueLi}/${Shemedrop}/ALL/${Performance}/ALL`)
                .then((response) => response.json())
                .then((data) => {

                    setData(data.data);
                    setloadingshow(false);
                    // console.log(data.data)
                })
                .catch((error) => {
                    //console.log("not found the api");
                });
        }
    }, [Performance, Shemedrop, valueLi]);
    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);

    const routeChange = (paramname) => {
        window.open("/Mutual-Fund/" + paramname.replace(/ /g, '_').replace('&', 'and').replace('+', ''), "_blank");
    }

    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/mutual-funds">Mutual Fund</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Fund Performance</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='fundperform-loser-sc'>
                            <div className='fundperform-header'>
                                <h2><span>Fund Performance</span></h2>
                            </div>
                            <MarketMF optionValue="Fund Performance" />
                            <div className='fundperform-dates'>
                                <ul>
                                    <li id="1Week" data-value="1Week" className={(valueLi === "1Week") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>1W</li>
                                    <li data-value="1Month" className={(valueLi === "1Month") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>1M</li>
                                    <li data-value="3month" className={(valueLi === "3month") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>3M</li>
                                    <li data-value="6month" className={(valueLi === "6month") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>6M</li>
                                    <li data-value="1year" className={(valueLi === "1year") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>1Y</li>
                                    <li data-value="3year" className={(valueLi === "3year") ? "active" : ''} onClick={(event) => { setValueLi(event.target.getAttribute("data-value")) }}>3Y</li>
                                </ul>
                            </div>
                            <div className='fundperform-right'>
                                <div className='fundperform-inner-select'>
                                    <select onChange={(event) => setPerformance(event.target.value)}>

                                        <option value='T' selected>Top performance</option>
                                        <option value='B'>Bottom Performance</option>

                                    </select>
                                </div>
                                <div className='xyfundperform-inner-select'>

                                    <select onChange={(event) => setSheme(event.target.value)}>
                                        {/* <option>All Equity</option> */}
                                        {DataFundPerformance && DataFundPerformance.map(
                                            ({ VCLASSCODE, VCLASS }) => (
                                                <option value={VCLASSCODE} selected={valuescheme === VCLASS}>{VCLASS}</option>
                                            )
                                        )}
                                    </select>
                                </div>

                            </div>
                            <div className='fundperform-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Scheme Name</th>
                                            <th className='text-right'>NAV(Rs)</th>
                                            <th className='text-right'>% Returns</th>
                                        </tr>
                                    </thead>
                                    {(() => {
                                        if (valueLi === "1Week") {
                                            return (
                                                <tbody>
                                                    {currentTableData && currentTableData.map(({ Sch_Name, week1, NavRs }) => (
                                                        <tr>
                                                            <td className='text-left'><h6 onClick={() => routeChange(Sch_Name)}>{Sch_Name}</h6></td>
                                                            <td className='text-right'>{(NavRs != null) ? NavRs.toFixed(2) : 0}</td>
                                                            <td className='text-right'>{(week1 != null) ? week1.toFixed(2) : 0}</td>


                                                        </tr>
                                                    ))}
                                                </tbody>
                                            )
                                        }
                                        else if (valueLi === "1Month") {
                                            return (
                                                <tbody>
                                                    {currentTableData && currentTableData.map(({ Sch_Name, month1, NavRs }) => (
                                                        <tr>
                                                            <td className='text-left'>{Sch_Name}</td>
                                                            <td className='text-right'>{(NavRs != null) ? NavRs.toFixed(2) : 0}</td>
                                                            <td className='text-right'>{(month1 != null) ? month1.toFixed(2) : 0} </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            )
                                        }
                                        else if (valueLi === "3month") {
                                            return (
                                                <tbody>

                                                    {currentTableData && currentTableData.map(({ Sch_Name, month3, NavRs }) => (
                                                        <tr>
                                                            <td className='text-left'>{Sch_Name}</td>
                                                            <td className='text-right'>{(NavRs != null) ? NavRs.toFixed(2) : 0}</td>
                                                            <td className='text-right'> {(month3 != null) ? month3.toFixed(2) : 0} </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            )
                                        }
                                        else if (valueLi === "6month") {
                                            return (
                                                <tbody>

                                                    {currentTableData && currentTableData.map(({ Sch_Name, month6, NavRs }) => (
                                                        <tr>
                                                            <td className='text-left'>{Sch_Name}</td>
                                                            <td className='text-right'>{(NavRs != null) ? NavRs.toFixed(2) : 0}</td>
                                                            <td className='text-right'>{(month6 != null) ? month6.toFixed(2) : 0}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            )
                                        }
                                        else if (valueLi === "1year") {
                                            return (
                                                <tbody>

                                                    {currentTableData && currentTableData.map(({ Sch_Name, year1, NavRs }) => (
                                                        <tr>
                                                            <td className='text-left'>{Sch_Name}</td>
                                                            <td className='text-right'>{(NavRs != null) ? NavRs.toFixed(2) : 0}</td>
                                                            <td className='text-right'>{(year1 != null) ? year1.toFixed(2) : 0}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            )
                                        }
                                        else if (valueLi === "3year") {
                                            return (
                                                <tbody>

                                                    {currentTableData && currentTableData.map(({ Sch_Name, year3, NavRs }) => (
                                                        <tr>
                                                            <td className='text-left'>{Sch_Name}</td>
                                                            <td className='text-right'>{(NavRs != null) ? NavRs.toFixed(2) : 0}</td>
                                                            <td className='text-right'>{(year3 != null) ? year3.toFixed(2) : 0}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            )
                                        }
                                    })()}
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Fundperformans;